import io from 'socket.io-client'
const debug = false
const url = debug === true ? 'http://localhost:5002' : 'https://delpacargo.delpasystem.com'
let socket = io(url)
export default  socket